import { render } from "./BookingExtrasModalCase2.vue?vue&type=template&id=019181c4"
import script from "./BookingExtrasModalCase2.vue?vue&type=script&lang=js"
export * from "./BookingExtrasModalCase2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/BookingExtrasModalCase2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "019181c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('019181c4', __exports__)) {
    api.reload('019181c4', __exports__)
  }
  
  module.hot.accept("./BookingExtrasModalCase2.vue?vue&type=template&id=019181c4", () => {
    api.rerender('019181c4', render)
  })

}


export default __exports__